<template lang='pug'>
.column-container(:class="{ reverse: reverse }")
    slot(name='left')
    slot(name='right')
</template>

<script>
export default {
    name: "ColumnContainer",
    props: {
        reverse: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang='sass' scoped>
.column-container
    justify-content: space-between

@media(min-width: $mobile-breakpoint)
    .column-container.reverse
        flex-direction: row-reverse
</style>